import axios from 'axios';
import { API_URL } from '../constants/http.constants';

export const createGuest = async (params) => {
  const res = await axios.post(`${API_URL}/guest`, params);
  return res.data;
};
